<template>
  <div ref="textOuter" :style="finalStyle">
    {{ content }}
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Object,
      default: null
    },
    hoverOptions: {
      type: Object,
      default: null
    },
    content: {
      type: String,
      default: null
    }
  },
  computed: {
    finalStyle() {
      return this.isHover ? this.hoverTextStyle : this.textStyle
    },
    textStyle() {
      return this.options ? this.getTextStyle(this.options) : {}
    },
    hoverTextStyle() {
      return this.hoverOptions ? this.getTextStyle(this.hoverOptions) : {}
    }
  },
  data() {
    return {
      isHover: false
    }
  },
  mounted() {
    if (this.hoverOptions) {
      this.$refs.textOuter.addEventListener("mouseenter", () => {
        this.isHover = true
      })
      this.$refs.textOuter.addEventListener("mouseleave", () => {
        this.isHover = false
      })
    } 
  },
  methods: {
    getTextStyle(textOptions) {
      let fontFamily1 = textOptions.fontFamily,
        fontSize1 = textOptions.fontSize,
        fontWeight1 = textOptions.fontWeight
      const lineHeight = textOptions.lineHeightType === '%' ? (textOptions.lineHeightType / 100) :
          textOptions.lineHeightType === 'normal'? "normal" :textOptions.lineHeightType + "px"
      return {
        display: "inline-block",
        "font-style": textOptions.fontStyle,
        "font-Family": fontFamily1,
        "text-indent": textOptions.textIndent ?? 0,
        "font-size": fontSize1 + "px",
        "font-weight": fontWeight1,
        "line-height": lineHeight ,
        "text-align": textOptions.textAlign,
        "writing-mode": textOptions.writingMode,
        "letter-spacing":
          textOptions.letterSpacingType === "%"
            ? textOptions.letterSpacing / 100 + "em"
            : textOptions.letterSpacing + "px",
        "--letterSpacing":
          textOptions.letterSpacingType === "%"
            ? "-" + textOptions.letterSpacing / 100 + "em"
            : "-" + textOptions.letterSpacing + "px",
        "text-shadow": this.getTextShadowStyle(textOptions),
        color: this.$parseColor(textOptions.fontColor),
        "text-decoration": textOptions.textDecoration
      }
    },
    getTextShadowStyle(options) {
      let tmpStyle = ""
      if (Array.isArray(options.shadowH)) {
        options.shadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle +=
            `${options.shadowH[index]}px ${options.shadowV[index]}px ${options.shadowBlur[index]}px ${this.$parseColor(options.shadowColor[index])}`
        })
      } else {
        tmpStyle +=
          `${options.shadowH}px ${options.shadowV}px ${options.shadowBlur}px ${this.$parseColor(options.shadowColor)}`
      }
      return tmpStyle
    }
  }
}
</script>
<style lang="scss" scoped>
.text-container {
}
</style>
